import type { RenewalNote } from '@policyvision/contracts';

import { Skeleton } from '@/common/components/ui/skeleton';

import RenewalEmptyNotes from './RenewalEmptyNotes';
import RenewalNotesList from './RenewalNotesList';

interface RenewalNotesTabContentProps {
  isLoading: boolean;
  hasNotes: boolean;
  groupedNotes: Record<string, RenewalNote[]>;
}

export const RenewalNotesTabContent = ({
  isLoading,
  hasNotes,
  groupedNotes,
}: RenewalNotesTabContentProps) => {
  if (isLoading) {
    return <Skeleton className="px-4 py-45 text-center" />;
  }

  if (hasNotes) {
    return <RenewalNotesList groupedNotes={groupedNotes} />;
  }

  return <RenewalEmptyNotes />;
};
